


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getList: '/pos/paginated',
    getById: '/pos/id',
    create: '/pos/save',
    update: '/pos/update',
    delete: '/pos/delete'
}

const usePositionRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getPositionList = async (payload) => {
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getPositionById = async (payload) => {
        return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const createPosition = async (payload) => {
        return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const updatePosition = async (payload) => {
        return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const deletePosition = async (payload) => {
        return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
    }
    return {
        isLoading,
        data,
        error,
        getPositionList,
        getPositionById,
        createPosition,
        updatePosition,
        deletePosition
    }
}

export default usePositionRepo
